import react, {useState, useEffect} from "react";
import MapBase from "./MapBase";
import {green, grey, red, orange } from '@mui/material/colors';

import "ol";
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat, toLonLat } from "ol/proj.js";
import Point from "ol/geom/Point";
import { Feature } from "ol";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Control, defaults as defaultControls} from 'ol/control';
import {Icon, Style, Fill, Stroke, Circle, Text} from 'ol/style.js';
import { toSize } from "ol/size";
import LayerGroup from "ol/layer/Group";

import HouseIcon from '@mui/icons-material/House';

const defaultStroke = new Stroke({
  color: 'black',//[64, 64, 64, 0.8],
  width: 1.0
});

var greenStyle = new Style({
  image: new Circle({
      radius: 5,
      stroke: defaultStroke,
      fill: new Fill({
          color: red[500]//[255, 102, 102, 0.5]
      })
      }),
});

var grayStyle = new Style({
  image: new Circle({
      radius: 4,
      stroke: defaultStroke,
      fill: new Fill({
          color: grey[300]//[255, 102, 102, 0.5]
      })
      }),
});

// var iconStyle = new Style({
//   image: new Icon({
//     anchor: [0.5, 46],
//     anchorXUnits: 'fraction',
//     anchorYUnits: 'pixels',
//     color: 'red',
//     src: "house.png"
//   })
// })

// var fontStyle = new Style({
//   text: new Text({

//   })
// })


export const SingleSolutionMap = ({assignments, stationList, ...props}) => {

  const sanAntonioCenter = [-98.491142, 29.424349];
  const [customLayers, setCustomLayers] = useState([]);
  useEffect(() => {
    if (assignments != null){
      processData(assignments, stationList);
    }
  }, [assignments, stationList])

  const createSolnLayer = (pauAssignments) => {
    let featureList = [];
    pauAssignments.forEach(ele => {
      let point = new Point(fromLonLat([ele.station.longitude, ele.station.latitude]));
      let feature = new Feature({
        geometry: point
      });// don't need anything else atm
      featureList.push(feature);
    });
    //create vector layer for stations
    let newLayer = new VectorLayer({
      source: new VectorSource({
        features: featureList
      }),
      style: greenStyle,
    });
    return newLayer;
  }

  const createOtherStationLayer = (stationList, pauAssignments) => {
    let featureList = [];
    let stationsInUse = [];
    pauAssignments.forEach(assign => {
      stationsInUse.push(assign.station.name);
    });
    stationList.forEach(station => {
      if (!stationsInUse.includes(station.name)){
        let point = new Point(fromLonLat([station.longitude, station.latitude]));
        let feature = new Feature({
          geometry: point
        });
        featureList.push(feature);
      }
    })

    let newLayer = new VectorLayer({
      source: new VectorSource({
        features: featureList
      }),
      style: grayStyle
    });
    return newLayer;
  }

  const processData = (assigns, stationList) => {
    //create list of features from stations
    let Layers = [];
    let newLayer = createSolnLayer(assigns);
    Layers.push(newLayer);
    if (stationList !== null && stationList.length > 0){
      Layers.push(createOtherStationLayer(stationList, assigns));
    }
    setCustomLayers(Layers);
  }

  return (
    <MapBase CustomLayers={customLayers} mapCenter={sanAntonioCenter} {...props}/>
  )

}